import React from 'react';
import { ConversationHistory } from '@/components/conversation-history';

interface NavChatsProps {
  className?: string;
}

export const NavChats = React.memo(function NavChats({ className }: NavChatsProps) {
  return (
    <div className={className}>
      <ConversationHistory />
    </div>
  );
});
